import { Injectable } from '@angular/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class FallbackTranslator implements MissingTranslationHandler {
  handle({ key, translateService }: MissingTranslationHandlerParams) {
    // Entro qui se la traduzione nella lingua selezionata manca -> non c'è proprio la key nella lista di traduzioni
    const translations = translateService.translations;

    // Cerco la traduzione nella lingua di default -> quella del sistema operativo
    const defaultLangTranslations = translations[translateService.defaultLang];
    if (defaultLangTranslations?.[key]) return defaultLangTranslations[key];

    // Come ultima spiaggia uso l'inglese americano
    const fallbackTranslations = translations['en-US'];
    if (fallbackTranslations?.[key]) return fallbackTranslations[key];

    // Ogni check è fallito, torno la chiave
    return key;
  }
}
